import React from "react";
import HeaderPanel from "../../../components/layout/HeaderPanel";
import { formatMessage, formatMessageWithParams } from "../../../utils/helpers/LanguageHelper";
import { ItemRenderProps, processTreeViewItems, TreeView } from "@progress/kendo-react-treeview";
import FooterPanel from "../../../components/layout/FooterPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { ButtonVariants } from "../../../styles/fluent/ButtonVariants";
import { useDownloadCopyPage } from "./useDownloadCopyPage";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = mergeStyleSets({
  contentWrap: { padding: "10px" },
  info: { color: "#A3A3A3" },
  footerContent: { display: "flex", justifyContent: "space-between" },
});

export function DownloadCopyPage() {
  const { download, goBack, rootDocument, onToggle, treeItems, onExpandChange } = useDownloadCopyPage();

  return (
    <div>
      <HeaderPanel applyPadding>
        {formatMessageWithParams("cof.downloadcopy.title", {
          documentName: rootDocument?.text,
        })}
      </HeaderPanel>
      <div className={classNames.contentWrap}>
        <span className={classNames.info}>{formatMessage("cof.downloadcopy.info")}</span>

        <TreeView
          data={processTreeViewItems(treeItems, {})}
          item={CustomTreeItem}
          checkboxes={true}
          onCheckChange={onToggle}
          expandIcons={true}
          onExpandChange={onExpandChange}
        />
      </div>
      <FooterPanel>
        <div className={classNames.footerContent}>
          <PrimaryButton className={ButtonVariants.white} text={formatMessage("cof.base.back")} onClick={goBack} />
          <PrimaryButton
            id="start-download-copy"
            text={formatMessage("cof.downloadcopy.button.text")}
            onClick={download}
          />
        </div>
      </FooterPanel>
    </div>
  );
}

const CustomTreeItem: React.FunctionComponent<ItemRenderProps> = function (props) {
  return <span style={{ fontWeight: props.itemHierarchicalIndex === "0" ? "bold" : "auto" }}>{props.item.text}</span>;
};
